import { render, staticRenderFns } from "./GetDemo.vue?vue&type=template&id=36d00656"
import script from "./GetDemo.vue?vue&type=script&lang=js"
export * from "./GetDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports